export const themes = {
    Cars: "cars",
    Ghosts: "ghosts",
    Bouncing: "bouncing",
    Gingerbread: "gingerbread"
};